import { InjectionToken } from '@angular/core';
import { BulkEntityService } from '../../../../softline/entity.service';
import { Entity } from '../types/entity';

export const BULK_ENTITY_SERVICE = new InjectionToken<
  BulkEntityService<Entity>
>('BULK_ENTITY_SERVICE');
